import { TYPES } from '../../common/constants';

export const setContactFormData = payload => ({
  type: TYPES.SET_CONTACT_FORM_DATA,
  payload,
});
export const clearContactFormData = () => ({
  type:TYPES.CLEAR_CONTACT_FORM_DATA,
 })